customElements.whenDefined('variant-picker').then(() => {
  if (new URLSearchParams(window.location.search).has('variant')) return;

  document.querySelectorAll('variant-picker').forEach((picker) => {
    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const checked = inputs.find((input) => input.checked);

      if (!checked || checked.value.toUpperCase() !== 'XS') return;

      const mInput = inputs.find(
        (input) => input.value.toUpperCase() === 'M' && input.dataset.optionAvailable === 'true'
      );

      if (mInput) mInput.click();
    });
  });
});
